import React from "react";
import { Heart, Sparkles, Star } from "lucide-react";

// Tactile-romance ambient decor: soft color blobs, drifting hearts & twinkles.
const blobs = [
  { top: "-6%", left: "-4%", size: 360, color: "#F8D7D3" },
  { top: "30%", right: "-8%", size: 420, color: "#FBE7D6" },
  { bottom: "-10%", left: "12%", size: 380, color: "#E6EDE2" },
  { bottom: "8%", right: "6%", size: 300, color: "#F8D7D3" },
];

const hearts = [
  { top: "12%", left: "6%", size: 26, rot: "-12deg", dur: "9s", op: 0.18 },
  { top: "22%", right: "10%", size: 18, rot: "10deg", dur: "11s", op: 0.16 },
  { top: "55%", left: "4%", size: 32, rot: "8deg", dur: "10s", op: 0.14 },
  { top: "70%", right: "14%", size: 22, rot: "-8deg", dur: "12s", op: 0.18 },
  { bottom: "10%", left: "40%", size: 20, rot: "14deg", dur: "8s", op: 0.15 },
  { top: "40%", left: "48%", size: 16, rot: "-6deg", dur: "13s", op: 0.12 },
];

const twinkles = [
  { top: "18%", left: "30%", size: 16, dur: "3.5s", icon: "spark" },
  { top: "34%", right: "22%", size: 14, dur: "4.5s", icon: "star" },
  { top: "62%", left: "22%", size: 14, dur: "3s", icon: "star" },
  { bottom: "22%", right: "30%", size: 18, dur: "5s", icon: "spark" },
  { top: "8%", right: "38%", size: 12, dur: "4s", icon: "star" },
];

export default function BackgroundDecor() {
  return (
    <div className="bg-decor" aria-hidden="true" data-testid="background-decor">
      {blobs.map((b, i) => (
        <div
          key={`b${i}`}
          className="blob"
          style={{
            top: b.top,
            left: b.left,
            right: b.right,
            bottom: b.bottom,
            width: b.size,
            height: b.size,
            background: b.color,
            animationDelay: `${i * 2}s`,
          }}
        />
      ))}

      {hearts.map((h, i) => (
        <Heart
          key={`h${i}`}
          className="decor-float text-[#D95F59] fill-[#D95F59]"
          style={{
            top: h.top,
            left: h.left,
            right: h.right,
            bottom: h.bottom,
            width: h.size,
            height: h.size,
            opacity: h.op,
            "--rot": h.rot,
            "--dur": h.dur,
            animationDelay: `${i * 0.7}s`,
          }}
        />
      ))}

      {twinkles.map((t, i) =>
        t.icon === "spark" ? (
          <Sparkles
            key={`t${i}`}
            className="decor-twinkle text-[#E0A96D]"
            style={{ top: t.top, left: t.left, right: t.right, bottom: t.bottom, width: t.size, height: t.size, "--dur": t.dur, animationDelay: `${i * 0.5}s` }}
          />
        ) : (
          <Star
            key={`t${i}`}
            className="decor-twinkle text-[#8C9A86] fill-[#8C9A86]"
            style={{ top: t.top, left: t.left, right: t.right, bottom: t.bottom, width: t.size, height: t.size, "--dur": t.dur, animationDelay: `${i * 0.5}s` }}
          />
        )
      )}
    </div>
  );
}
